/** The comparison's tabs; the route keeps the open one in its `tab` query param. */
export const comparisonTabs = ['lineItems', 'supplier', 'manufacturer', 'demands', 'settings'] as const;

export type ComparisonTab = (typeof comparisonTabs)[number];

/** The `tab` query param and its writer, which the comparison pages take from their route. */
export interface ComparisonTabSearch {
    tab: ComparisonTab | undefined;
    onSearchChange: (patch: { tab?: ComparisonTab }) => void;
}
